import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  id: "minorsCheckinWrapper",
  class: "flex-col view-wrapper"
}
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = {
  id: "minorsForm",
  class: "flex-col"
}
const _hoisted_4 = { class: "form-wrapper" }
const _hoisted_5 = { class: "is-participating" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_minor_info_form = _resolveComponent("minor-info-form")!
  const _component_yes_no_input = _resolveComponent("yes-no-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "back-btn",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goBack()))
      }),
      _cache[5] || (_cache[5] = _createElementVNode("h3", { class: "page-title" }, "Add minors", -1))
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.minors, (m, i) => {
        return (_openBlock(), _createBlock(_component_minor_info_form, {
          key: m.guid,
          minor: m,
          index: i,
          activityDate: _ctx.activityDate,
          onRemoveMinor: _cache[1] || (_cache[1] = ($event: any) => (_ctx.deleteMinor($event))),
          minAge: _ctx.minAge,
          ref_for: true,
          ref: 'minor' + i
        }, null, 8, ["minor", "index", "activityDate", "minAge"]))
      }), 128)),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_yes_no_input, {
            label: _ctx.adultName,
            yesBtn: { label: `I'm checking in myself & minors`, selected: _ctx.adultIsParticipating },
            noBtn: { label: `I'm checking in minors only` },
            uniformPadding: 22,
            onOnStatusChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.adultIsParticipating = $event))
          }, null, 8, ["label", "yesBtn"])
        ])
      ]),
      _createElementVNode("button", {
        class: "form-btn add-more-btn",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.addNewMinor()))
      }, "Add another minor"),
      _createElementVNode("button", {
        class: "form-submit-btn",
        onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.onNext()), ["stop"]))
      }, "Next")
    ])
  ]))
}